import React, { useEffect } from 'react';
import PostCard from '../posts/PostCard';
import { useStoriesStore } from '../../stores/useDataStore'; // 🟢 1. Importamos el store de historias
import { useFeedStore } from '../../stores/useDataStore'; // 🟢 2. Importamos el store del feed para las acciones
import { useModalStore } from '../../stores/useUIStore'; // 🟢 3. Importamos el store de modales

const MemoriesModal = ({ isOpen, onClose }) => {
  // 🟢 4. Obtenemos los datos y acciones directamente de los stores
  const memories = useStoriesStore((state) => state.memories);
  const isLoading = useStoriesStore((state) => state.isLoading);
  const fetchMemories = useStoriesStore((state) => state.fetchMemories);
  const likePost = useFeedStore((state) => state.likePost);
  const openModal = useModalStore((state) => state.openModal);

  useEffect(() => {
    if (isOpen) {
      fetchMemories();
    }
  }, [isOpen, fetchMemories]);

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-75 z-50 flex items-center justify-center"
      onClick={onClose}
    >
      <div
        className="bg-gray-100 rounded-lg shadow-xl max-w-2xl w-full p-6"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-2xl font-bold text-gray-800">Tus Recuerdos</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-800 text-2xl"
          >
            &times;
          </button>
        </div>

        <div className="max-h-[70vh] overflow-y-auto space-y-4 pr-2">
          {isLoading ? (
            <div className="text-center py-10 text-gray-500">Cargando recuerdos...</div>
          ) : memories && memories.length > 0 ? (
            memories
              .filter(Boolean)
              .map((post) => (
                <PostCard
                  key={post._id}
                  post={post}
                  onLike={likePost}
                  openModal={() =>
                    openModal('commentModal', { postId: post._id })
                  }
                />
              ))
          ) : (
            <div className="text-center py-10">
              <i className="fas fa-box-open text-4xl text-gray-400 mb-3"></i>
              <p className="text-gray-600">No tienes recuerdos de este día.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MemoriesModal;
